import QRCode from "qrcode";

/**
 * PNG data URL for a QR code encoding `text` (ticket 08). Empty text or an
 * encoding failure resolves to `""` so callers fall back to the placeholder
 * exactly like QrSvg does for a failed SVG render.
 */
export async function qrToPngDataUrl(text: string): Promise<string> {
  if (!text) return "";
  try {
    return await QRCode.toDataURL(text, { errorCorrectionLevel: "M", margin: 1, width: 512 });
  } catch {
    return "";
  }
}
